const foreign_worker_modal = {
  title: "Add Foreign Worker Profile Groups",
  headerText:
    "Select the profile groups below that you want to add this profile to.",
  saveBtnText: "Add to Groups",
};

export default foreign_worker_modal;
